export default __webpack_public_path__ + "static/media/151-tools-and-utensils.d1901505.png";